module.exports = __webpack_public_path__ + "7d00e3c453bb433000d026e0e4b13770.png";